import { createSlice } from "@reduxjs/toolkit";
import { animateCss } from "../../../pages/TosterAlert";

import { Button, styled } from "@mui/material";
import { allArbitratorsAction, allMediatorsAction, boardsAndPanelEmpanelmentFetchDocumentAction, boardsAndPanelEmpanelmentRegistrationViewAction } from "../../actions/boardsAndPanel/boardsAndPanelAction";

const boardsAndPanelInitialState = {
    data:[],
    document:[],
    view:[],
    loading: false,
    error: "",
};

const StyledButton = styled(Button)(({ theme }) => ({
  color: "white",
  marginLeft: theme.spacing(1),
}));

const boardsAndPanelSlice = createSlice({
  name: "boardsAndPanel",
  initialState: boardsAndPanelInitialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(allArbitratorsAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(allArbitratorsAction.fulfilled, (state, action) => {
        state.data=action.payload?.data??[];
        state.loading = false;
        return state;
      })
      .addCase(allArbitratorsAction.rejected, (state, action) => {
        state.loading = false;
      })

        .addCase(allMediatorsAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(allMediatorsAction.fulfilled, (state, action) => {
        state.data=action.payload?.data??[];
        state.loading = false;
        return state;
      })
      .addCase(allMediatorsAction.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(boardsAndPanelEmpanelmentFetchDocumentAction.pending, (state, action) => {
        state.loading = true;
      })
       .addCase(boardsAndPanelEmpanelmentFetchDocumentAction.fulfilled, (state, action) => {
        state.document=action.payload?.data??[];
        state.loading = false;
        return state;
      })
      .addCase(boardsAndPanelEmpanelmentFetchDocumentAction.rejected, (state, action) => {
        state.loading = false;
      })

        .addCase(boardsAndPanelEmpanelmentRegistrationViewAction.pending, (state, action) => {
        state.loading = true;
      })
       .addCase(boardsAndPanelEmpanelmentRegistrationViewAction.fulfilled, (state, action) => {
        state.view=action.payload?.data??[];
        state.loading = false;
        return state;
      })
      .addCase(boardsAndPanelEmpanelmentRegistrationViewAction.rejected, (state, action) => {
        state.loading = false;
      })
    
});

// boardsAndPanelEmpanelmentRegistrationViewAction
export default boardsAndPanelSlice.reducer;
